import React, { useEffect, useState } from "react";
import IndexHeader from "./IndexHeader";
import IndexProductsCard from "./IndexProductsCard";

export interface IndexProductsProps {}

const IndexProducts: React.FC<IndexProductsProps> = (props: IndexProductsProps) => {

	return (
		<>
			<IndexHeader title="Products">
				Combined Platforms designs, builds and operates a number of Software-as-a-Service (SaaS) platforms.
				<br />
				<br />
				The full range of current and upcoming releases are outlined below:
			</IndexHeader>

			<div id="indexproducts-container" className="space-y-8 pt-2">
				<IndexProductsCard index={0} name="Design Shift" headline="Automate the process of bringing designs across to your developers." description="Use our tools and GPT-4o to generate the components you want from Uizard layouts, directly into your development environment." image="indexproductscard_000010.png" url="https://designshift.dev" />
				<IndexProductsCard index={1} name="Monologue" headline="Supercharge the path from thought to execution." description="Chart a path from idea through research and product development, up to execution." image="indexproductsmonologue_000039.png" />
			</div>
		</>
	);

};

export default IndexProducts;